export default __webpack_public_path__ + "static/media/grid.6a65b5e6.svg";